import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { connect } from "react-redux";
import { setCustomerName } from "../../reducers/actions";
import { utcToLocal } from "../../utils/dateConvert";
import { Link } from "react-router-dom";

class IbuttonTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortString: "name",
      sortDirection: "asc",
    };
    this.sortStringName = "name";
    this.sortDirection = "asc";
  }
  componentDidMount() { }

  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };
  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({
        sortDirection: "des",
      });
      this.sortDirection = "des";
    } else {
      this.setState({
        sortDirection: "asc",
      });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.props.sortFunction(name, order);
  };

  renderSortHeader = (label, sortKey) => {
    const isActive = this.state.sortString == sortKey;
    const iconClass = isActive
      ? this.state.sortDirection == "asc"
        ? "fa-sort-amount-asc"
        : "fa-sort-amount-desc"
      : "fa-exchange";

    return (
      <button
        className={`ibutton-sort-button ${isActive ? "active" : ""}`}
        onClick={() => {
          if (isActive) {
            this.handleSortDirection();
          } else {
            this.handleSortString(sortKey);
          }
        }}
        type="button"
      >
        {label}
        <i className={`fa ${iconClass}`} />
      </button>
    );
  };

  normalizeStatus = (status) => {
    const normalizedStatus = (status || "").toString().toLowerCase();

    if (normalizedStatus === "disabled" || normalizedStatus === "disable" || normalizedStatus === "0") {
      return "disabled";
    }

    if (normalizedStatus === "active" || normalizedStatus === "1") {
      return "active";
    }

    return "unknown";
  };

  normalizeConnectionState = (state) => {
    const normalizedState = (state || "").toString().toLowerCase();

    if (normalizedState === "connected") {
      return "connected";
    }

    if (normalizedState === "disconnected") {
      return "disconnected";
    }

    return "unknown";
  };

  render() {
    const { customers } = this.props;

    return (
      <div className="ibutton-table-wrap">
      <Table className="ibutton-modern-table">
        <thead>
          <tr>
            <th>{this.renderSortHeader("Customer", "customer")}</th>
            <th>Serial No </th>
            <th>{this.renderSortHeader("Name", "name")}</th>
            <th>{this.renderSortHeader("State", "state")}</th>
            <th>{this.renderSortHeader("Last Event", "lastevent")}</th>
            <th>Asset </th>
            <th>{this.renderSortHeader("Last Connected", "lastconnected")}</th>
            <th>{this.renderSortHeader("Last Disconnected", "lastdisconnected")}</th>
            <th>Status </th>

            <th className="ibutton-actions-heading"></th>
          </tr>
        </thead>
        <tbody>
          {customers.length === 0 && (
            <tr>
              <td className="ibutton-empty" colSpan="10">
                No iButtons match your search.
              </td>
            </tr>
          )}
          {customers.map((customer, index) => {
            const stateClass = this.normalizeConnectionState(customer.state);
            const statusClass = this.normalizeStatus(customer.status);
            return (
              <tr key={customer.id || index}>
                <td><strong>{customer.customerName || "-"}</strong></td>
                <td>{customer.serialNo || "-"}</td>
                <td>{customer.name || "-"}</td>
                <td>
                  <span className={`ibutton-connection ibutton-connection-${stateClass}`}>
                    {customer.state || "-"}
                  </span>
                </td>
                <td>{utcToLocal(customer.lastevent)}</td>
                <td>{customer.assetName || "-"}</td>
                <td>{utcToLocal(customer.lastConnect)}</td>
                <td>{utcToLocal(customer.lastDisconnect)}</td>
                <td>
                  <span className={`ibutton-status ibutton-status-${statusClass}`}>
                    {customer.status || "-"}
                  </span>
                </td>
                <td className="ibutton-actions">
                  <Link to={`/ibuttonDetails/${customer.id}`}>Edit</Link>
                  <Link to={`/deleteIbutton/${customer.id}`}>Delete</Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  customerName: state.customerName,
});
const mapDispatchToProps = {
  setCustomerNameAction: setCustomerName,
};

export default connect(mapStateToProps, mapDispatchToProps)(IbuttonTable);
